export class DoctorGender {
  genderName: string;
  status: boolean;
  id: number;
  genderType?: number;
}
